import React from 'react'
import { Link } from 'react-router-dom';
import { useSyncedStore } from '@syncedstore/react';

import { todoStore } from 'src/store/todo';

import Container from '../shared/container';
import TeamCard from '../shared/cards/team';
import Fallback from '../shared/fallback';

const Teams: React.FC = () => {
    const state = useSyncedStore(todoStore);

    const teams = state.teams || [];
    const workers = state.workers || [];

    const getWorkerCount = (teamId: string) => {
        return workers.filter(w => w.teamId === teamId && w.isActive).length;
    };

    const getWorkersOutCount = (id: string) => {
        const workersOut = state.workerOuts.filter(w =>
            w.teamId === id && !w.softDeleted
        );
        if (workersOut.length > 0) {
            return workersOut.length;
        }

        return 0;
    }

    return (
        <Container>
            <div className='flex flex-col gap-2 w-full pt pb-20'>
                {teams.length > 0 ?
                    (teams.map((t) => (
                        <Link key={t.id} to={`/team/${t.id}?name=${t.teamName}`}>
                            <TeamCard
                                title={t.teamName}
                                description={t.teamDescription}
                                workersOutCount={getWorkersOutCount(t.id)}
                                count={`${getWorkerCount(t.id)}`} />
                        </Link>
                    ))) : <Fallback title='No team found!' />
                }
            </div>
        </Container>
    )
}

export default Teams
